import { Component, Input, SimpleChanges, Output, EventEmitter, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { PlayoutService } from 'app/services/playout.service';

@Component({
	selector: 'playout-details-controlbar',
	templateUrl: './playout-details-controlbar.component.html',
	styleUrls: ['./playout-details-controlbar.component.scss']
})

export class PlayoutDetailsControlbarComponent implements OnInit, OnChanges, OnDestroy {
	@Output() playoutUpdated: EventEmitter<any> = new EventEmitter<any>();

	@Input() playout: any;
	@Input() form: NgForm;

	volumeSetting: string;

	constructor(public playoutService: PlayoutService) { }

	ngOnInit() {
		this.volumeSettingCheck();
	}

	ngOnChanges(simpleChanges: SimpleChanges) {
		if (simpleChanges && simpleChanges.playout) {
			this.volumeSettingCheck();
		}
	}

	ngOnDestroy() {
	}

	volumeSettingCheck() {
		if (this.playout.muteButton !== 'Show') {
			this.volumeSetting = 'hide';
		} else if (this.playout.volume !== 'Show') {
			this.volumeSetting = 'mute_only';
		} else if (this.playout.volumeOrientation !== 'horizontal') {
			this.volumeSetting = 'vertical_slider';
		} else {
			this.volumeSetting = 'horizontal_slider';
		}
	}

	volumeSettingChanged() {
		switch (this.volumeSetting) {
			default:
			case 'horizontal_slider':
				this.playout.muteButton = 'Show';
				this.playout.volume = 'Show';
				this.playout.volumeOrientation = 'horizontal';
				break;

			case 'vertical_slider':
				this.playout.muteButton = 'Show';
				this.playout.volume = 'Show';
				this.playout.volumeOrientation = 'vertical';
				break;

			case 'mute_only':
				this.playout.muteButton = 'Show';
				this.playout.volume = 'Hide';
				break;

			case 'hide':
				this.playout.muteButton = 'Hide';
				this.playout.volume = 'Hide';
				break;
		}
		this.playoutUpdated.emit({
			muteButton: this.playout.muteButton,
			volume: this.playout.volume,
			volumeOrientation: this.playout.volumeOrientation
		});
		this.form?.form?.markAsDirty();
	}

	log(a: any) {
		console.warn('log', a);
	}
}
